import clsx from "clsx";
import styles from "./Section.module.less";

export const SectionCallout = ({ background = "violet-1000", children }) => {
  const backgroundClassName = background?.replace(/-/g, "_").toLowerCase();

  return <div className={clsx(styles.SectionCallout, styles[backgroundClassName])}>{children}</div>;
};
